/*
 * @Description: 导航数据
 * @Author: ywl
 * @Date: 2021-03-29 16:33:24
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2021-08-28 18:05:10
 */
const menuList = [{
    id: 301,
    parentId: 0,
    name: "题目",
    iconName: '1',
    url: "/questionnaire/edit/subject.html",
    urls: ["/questionnaire/edit/subject.html", '/questionnaire/edit/questionBank.html', "/questionnaire/edit/outline.html"]
},
// {
//     id: 320,
//     parentId: 0,
//     name: "题库",
//     url: "/questionnaire/edit/questionBank.html",
//     iconName: '3',
// },
// {
//     id: 310,
//     parentId: 0,
//     name: "大纲",
//     iconName: '2',
//     url: "/questionnaire/edit/outline.html",
// },

{
    id: 330,
    parentId: 0,
    name: "设置",
    url: "/questionnaire/edit/setting.html",
    iconName: '4',
},

{
    id: 350,
    parentId: 0,
    name: "风格",
    url: "/questionnaire/edit/style.html",
    iconName: '组318',
},
{
    id: 340,
    parentId: 0,
    name: "逻辑",
    url: "/questionnaire/edit/logic.html",
    iconName: '5',
},
];


export { menuList };
